import {
	ProSidebar,
	Menu,
	MenuItem,
	SidebarHeader,
	SidebarContent,
	SidebarFooter,
} from "react-pro-sidebar";
import { navconfig } from "../_navElement";
import modusLogo from "../../../asset/Modus_logo.png";
import "./style.css";
import classes from "./style.module.scss";
import { useNavigate } from "react-router-dom";
import {
	CLIENT_ADMINISTRATOR,
	USER,
	SYSTEM_ADMINISTRATOR,
} from "../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTab } from "../../../redux/ducks/auth";

const Sidebar = () => {
	const { userRole, currentTab } = useSelector(state => state.auth);
	const dispatch = useDispatch();
	const customStyle = {
		selected: {
			background: "#38d0d0",
			color: "white",
		},
		unSelected: {
			background: "#fafafa",
			color: "black",
		},
		headerStyle: {
			cursor: "pointer",
			height: "2.5em",
			margin: "2em",
		},
	};
	const role = userRole;
	const navigate = useNavigate();

	const getMenuItem = role => {
		if (role === CLIENT_ADMINISTRATOR) return navconfig.Org_Admin.items;
		else if (role === SYSTEM_ADMINISTRATOR) return navconfig.Sys_Admin.items;
		else return navconfig.user.items;
	};
	const MenuItemList = getMenuItem(role);

	return (
		<div id='header'>
			<ProSidebar>
				<SidebarHeader style={customStyle.headerStyle}>
					<div>
						<img
							src={modusLogo}
							onClick={() => navigate("/base/home")}
							className={classes["logoStyle"]}
							alt=''
						/>
					</div>
				</SidebarHeader>
				<SidebarContent>
					<Menu iconShape='square'>
						{MenuItemList.map(({ icon, label, to }, key) => {
							return (
								<MenuItem
									key={key}
									icon={icon}
									onClick={() => {
										dispatch(setCurrentTab(key));
										navigate(to);
									}}
									style={
										currentTab === key
											? customStyle.selected
											: customStyle.unSelected
									}>
									{label}
								</MenuItem>
							);
						})}
					</Menu>
				</SidebarContent>
				<SidebarFooter></SidebarFooter>
			</ProSidebar>
		</div>
	);
};

export default Sidebar;
